module.exports = __webpack_public_path__ + "img/img-basketball.46aac561.png";